export default __webpack_public_path__ + "static/media/Patterns.ee0a4552.svg";